import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "ATR Short ID:", -1);
const _hoisted_3 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_4 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Job Title:", -1);
const _hoisted_6 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_7 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Stage:", -1);
const _hoisted_9 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_10 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Assignee:", -1);
const _hoisted_12 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_13 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Doctype:", -1);
const _hoisted_15 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_16 = {
    key: 0,
    class: "flex justify-end"
};
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("b", null, "*Please ensure that all mandatory fields are completed and the Job Description has been attached before submitting for approval", -1);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("b", null, "*For compatible browsers please review this link. If your browser is not compatible it may effect the text you see within multi line text boxes and /or the speed of the people search.", -1);
import { Auth } from 'aws-amplify';
import { computed, inject, onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import formEight from '@/components/approvalWorkflowForms/advertisingRequirements.vue';
import formThirteen from '@/components/approvalWorkflowForms/candidateSelection.vue';
import formSeven from '@/components/approvalWorkflowForms/contractDetails.vue';
import formTwelve from '@/components/approvalWorkflowForms/firstSecondApproval.vue';
import formTwo from '@/components/approvalWorkflowForms/hiringSecondaryDetails.vue';
import formFour from '@/components/approvalWorkflowForms/jobDetails.vue';
import formFive from '@/components/approvalWorkflowForms/organisationDetails.vue';
import formNine from '@/components/approvalWorkflowForms/preEmployment.vue';
import formThree from '@/components/approvalWorkflowForms/recruitmentReason.vue';
import formTen from '@/components/approvalWorkflowForms/sercurityForm.vue';
import formEleven from '@/components/approvalWorkflowForms/specialistRoles.vue';
import formOne from '@/components/approvalWorkflowForms/taleoRecruitment.vue';
import formSix from '@/components/approvalWorkflowForms/workingHours.vue';
import httpClient from '@/httpClient';
import formLayout from '@/layouts/formLayout.vue';
import { saveStorage } from '@/storageSave';
export default /*#__PURE__*/ _defineComponent({
    __name: 'step8RecruitmentFeedback',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const formPoint = ref(0);
        const stages = inject('stages', []);
        const navItemConfig = [
            {
                formPoint: 0,
                name: 'formOne',
                text: 'Taleo Recruitment',
                component: formOne,
                icon: 'UserCircleIcon',
            },
            {
                formPoint: 1,
                name: 'formThirteen',
                text: 'Candidate Selection',
                component: formThirteen,
                icon: 'UserIcon',
            },
            {
                formPoint: 2,
                name: 'formTwo',
                text: 'Hiring Manager & Secondary Contact Details',
                component: formTwo,
                icon: 'UserIcon',
            },
            {
                formPoint: 3,
                name: 'formThree',
                text: 'Recruitment Reason',
                component: formThree,
                icon: 'LogoutIcon',
            },
            {
                formPoint: 4,
                name: 'formFour',
                text: 'Job Details',
                component: formFour,
                icon: 'EmojiHappyIcon',
            },
            {
                formPoint: 5,
                name: 'formFive',
                text: 'Organisation Details',
                component: formFive,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 6,
                name: 'formSix',
                text: 'Working Hours',
                component: formSix,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 7,
                name: 'formSeven',
                text: 'Contract Details',
                component: formSeven,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 8,
                name: 'formEight',
                text: 'Advertising Requirements',
                component: formEight,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 9,
                name: 'formNine',
                text: 'Pre Employment Checks',
                component: formNine,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 10,
                name: 'formTen',
                text: 'Security',
                component: formTen,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 11,
                name: 'formEleven',
                text: 'Specialist Roles',
                component: formEleven,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 12,
                name: 'formTwelve',
                text: 'First & Second Line Approval',
                component: formTwelve,
                icon: 'DocumentTextIcon',
            },
        ];
        const formData = ref({
            resourcing: {},
            formOne: {},
            formTwo: {},
            formThree: {},
            formFour: {},
            formFive: {},
            formSix: {},
            formSeven: {},
            formEight: {},
            formNine: {},
            formTen: {},
            formEleven: {},
            formTwelve: {},
            formThirteen: {},
        });
        const configItems = ref({});
        const profile = computed(() => store.getters.getProfile);
        const currentNavItem = computed(() => navItemConfig.find((item) => item.formPoint === formPoint.value));
        const disableForm = computed(() => true);
        const docId = computed(() => router.currentRoute.value.params.id);
        const docOwner = computed(() => router.currentRoute.value.params.docOwner);
        const currentUserIsAssigned = () => {
            return (formData.value.currentAssignee?.toUpperCase() ===
                Auth.user.signInUserSession.idToken.payload.identities[0].userId
                    .split('@')[0]
                    .toUpperCase());
        };
        const hideCancel = computed(() => {
            return [
                'starter.notifyMoreNotifyHROps',
                'starter.notifyMoreInfoBudgetApprover',
                'starter.notifyMoreInfoBudgetApproval',
                'starter.cancelled',
                'starter.complete',
            ].includes(formData.value?.currentStageName);
        });
        const fetchFormData = async () => {
            try {
                const response = await httpClient.post('/bff/get-document', {
                    id: docId.value,
                    requestedBy: docOwner.value,
                });
                formData.value = response.data.body?.Item ?? {};
                saveStorage('formData', JSON.stringify(formData.value));
            }
            catch {
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: 'There was a problem loading the form data.',
                });
            }
        };
        const fetchConfigItems = async () => {
            try {
                const response = await httpClient.post('/config/all', {
                    requestedBy: 'something',
                });
                configItems.value = response.data.body;
            }
            catch {
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: 'There was a problem loading the configuration data.',
                });
            }
        };
        const findStage = (stageName, status) => {
            const stage = status === 'DRAFT' ? 'Work in progress' : status;
            const foundStage = stages.find((stage) => stage.stageName === stageName);
            if (foundStage)
                return foundStage.displayName;
            return stage;
        };
        const setCurrentNavItem = (value) => {
            formPoint.value = value;
        };
        const handleUpdateFormData = ({ formName, data, }) => {
            formData.value[formName] = data;
            saveStorage('formData', JSON.stringify(formData.value));
        };
        const handleCancelStarter = async () => {
            try {
                store.dispatch('setIsLoading', true);
                const id = formData.value.docId
                    ? formData.value.docId
                    : router.currentRoute.value.params.id;
                const requestedBy = profile.value?.userID;
                const docOwner = formData.value.requestedBy;
                await httpClient.post('/bff/cancel-request', {
                    id,
                    requestedBy,
                    docOwner,
                });
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'success',
                    title: 'Success!',
                    message: 'This starter request has been cancelled.',
                });
                store.dispatch('setIsLoading', false);
                router.push('/');
            }
            catch {
                store.dispatch('setIsLoading', false);
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: 'There was a problem cancelling the starter request.',
                });
            }
        };
        const handleSubmitForm = async ({ name, data, }) => {
            try {
                store.dispatch('setIsLoading', true);
                formData.value[name].saved = true;
                const payload = {
                    formData: { ...data },
                    requestedBy: docOwner.value,
                    id: docId.value,
                    stage: formData.value.currentStageName,
                };
                const res = await httpClient.post(`/bff/starter/${name}`, payload);
                formData.value = res.data.body?.Item ?? {};
                saveStorage('formData', JSON.stringify(formData.value));
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'success',
                    title: 'SAVED!',
                    message: 'The form has been saved.',
                });
                router.push('/');
                store.dispatch('setIsLoading', false);
            }
            catch (err) {
                console.log(err);
                formData.value[name].saved = false;
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: 'There was an error submitting the form',
                });
                store.dispatch('setIsLoading', false);
            }
        };
        const handleReassign = () => {
            const id = formData.value.docId;
            const docOwner = formData.value.requestedBy;
            router.push(`/re-assign/${id}/${docOwner}`);
        };
        onBeforeMount(async () => {
            await fetchFormData();
            await fetchConfigItems();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(formLayout, {
                "nav-item-config": navItemConfig,
                "current-nav-item": currentNavItem.value,
                "form-point": formPoint.value,
                "form-data": formData.value,
                "display-header": true,
                "config-data": configItems.value,
                "form-name": "leaverForm",
                onSetCurrentNavItem: setCurrentNavItem
            }, {
                pageTitle: _withCtx(() => [
                    _createTextVNode("Recruitment Feedback")
                ]),
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _hoisted_2,
                        _createTextVNode(),
                        _createElementVNode("dd", _hoisted_3, _toDisplayString(formData.value.shortId), 1)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createTextVNode(),
                        _createElementVNode("dd", _hoisted_6, _toDisplayString(formData.value.formThree?.jobTitle), 1)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createTextVNode(),
                        _createElementVNode("dd", _hoisted_9, _toDisplayString(findStage(formData.value.currentStageName, formData.value.status)), 1)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createTextVNode(),
                        _createElementVNode("dd", _hoisted_12, _toDisplayString(formData.value.formOne?.hiringManagerEmail ?? formData.value.currentAssigneeEmail), 1)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createTextVNode(),
                        _createElementVNode("dd", _hoisted_15, _toDisplayString(formData.value.docType), 1)
                    ]),
                    _createTextVNode(),
                    (profile.value?.ADMIN || profile.value?.H2R || profile.value?.RESOURCING)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("button", {
                                class: "text-center px-4 py-2 rounded-md text-white bg-green-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                                onClick: _withModifiers(handleReassign, ["prevent"])
                            }, "Re-assign")
                        ]))
                        : _createCommentVNode("", true)
                ]),
                pageSubtitle: _withCtx(() => [
                    _hoisted_17,
                    _hoisted_18,
                    _createTextVNode(),
                    _hoisted_19
                ]),
                navFooter: _withCtx(() => [
                    (formData.value.currentStageName &&
                        formData.value.currentStageName !== 'DRAFT' &&
                        (profile.value?.ADMIN ||
                            profile.value?.H2R ||
                            profile.value?.RESOURCING ||
                            currentUserIsAssigned())
                        && !hideCancel.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "w-full mt-2 text-center px-4 py-2 rounded-md text-white bg-red-700 hover:bg-red-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                            onClick: handleCancelStarter
                        }, "\n      Cancel Starter\n    "))
                        : _createCommentVNode("", true)
                ]),
                main: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(currentNavItem.value?.component), {
                        data: formData.value,
                        "form-data": formData.value[currentNavItem.value?.name],
                        "disable-form": disableForm.value,
                        "show-approval-steps": disableForm.value,
                        "config-data": configItems.value,
                        "config-items": configItems.value,
                        "onUpdate:formData": handleUpdateFormData,
                        onSubmitForm: handleSubmitForm
                    }, null, 40, ["data", "form-data", "disable-form", "show-approval-steps", "config-data", "config-items"]))
                ]),
                _: 1
            }, 8, ["current-nav-item", "form-point", "form-data", "config-data"]));
        };
    }
});
